import React from "react";
import PropTypes from "prop-types";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TableSortLabel, Tooltip } from "@mui/material"
import { customStyles, tableOptions } from "../../styles/tableStyle";
import { AddCircle } from "@mui/icons-material"
import CustomSelect from "../../lib/CustomSelect";
import { appMessages } from "../../constants/appMessages";

const { Card, CardHeader, CardContent, CardActions, Button, LinearProgress, Divider, Typography } = require("@mui/material");
const { FormGenerator } = require("../../lib");
const { commons, util } = require("../../commons");
const { validateFormData, formToObj } = require("../../lib/validator");
const { SnackBarWidget } = require("../../Widget");
const { projectManager, projectUser } = require("../../schema/formSchema/projectUser");
const { Grid, Radio, RadioGroup, FormControl, FormControlLabel, Paper } = require("@mui/material");

const moment = require("moment");
var dateFormat = require("dateformat");

class ProjectUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectUsers: [],
      formData: [],
      status: false,
      message: "",
      apiService: false,
      showForm: false,
      selectObj: {}
    };
  }

  componentDidMount() {
    let selectObjData = (this.props.type == "members") ? projectUser : projectManager
    this.setState({ selectObj: selectObjData }, async function () {
      this.getProjectUsers();
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.actionType !== this.props.actionType) {
      this.reload();
    }
  }

  reload = async () => {
    await this.resetForm();
    this.getProjectUsers();
  };
  closeForm = () => {
    this.setState({ showForm: false })

  }

  loadUsers = (e) => {
    this.setState({ showForm: true })
    let role = (this.props.type === "members") ? 'user' : 'manager'
    let params = { op: "getUser", role: role };
    commons.getAPIRes(params, "POST", "user").then(async apiRes => {
      let { selectObj } = this.state;

      if (apiRes.status) {
        let userList = apiRes.result;
        let result = await userList.reduce(async function (accumulator, item, index) {
          const accum = await accumulator;
          await (accum.push({ "_id": item['_id']['$oid'], name: item['name'] }));
          return accum;
        }, []);
        selectObj.value = []
        selectObj.names = []
        selectObj.options = result;
        this.setState({ selectObj: selectObj })
      }
    });
  };


  getProjectUsers = async () => {
    let users = []
    users = (this.props.type === "members") ? this.props.project.members : this.props.project.managers

    let params = { op: "getUser", users: users };
    commons.getAPIRes(params, "POST", "user").then(apiRes => {
      if (apiRes.status) this.setState({ projectUsers: apiRes.result, })
    });
  };


  handleMultiSelectChange = async (e, object) => {
    let formDataInput = [...this.state.formData];
    let foundIndex = formDataInput.findIndex(item => item.key === e.target.name);
    let { selectObj } = this.state;
    let k = selectObj.value
    let n = selectObj.names;
    let index = k.indexOf(object.props.value);
    if (index > -1) {
      k.splice(index, 1);
      n.splice(index, 1)
    }
    else {
      k.push(object.props.value)
      n.push(object.props.name)
    }
    selectObj.value = k;
    selectObj.names = n;
    this.setState({ selectObj: selectObj });
  };



  handleChange = e => {
    let { actionData } = this.props;
    let formDataInput = [...this.state.formData];
    formDataInput.find(item => {
      if (item.key === e.target.name) {
        item.value = item.type === "number" ? parseInt(e.target.value) : e.target.value;
      }
    });
    this.setState({ formData: formDataInput });

  };

  resetForm = async () => {
    let form = [...projectManager];
    if (this.props.type == "member") {
      form = [...projectUser]
    }
    this.setState({ formData: util.formatForm(form) });
  };

  loadDefaults = () => {
    this.setState({ status: false, message: '' })
    this.props.closeDialog()
    this.props.reloadPage()

  }
  addUsers = async () => {
    let { selectObj } = this.state;
    let { project, type } = this.props;
    let params = { "_id": project['_id']['$oid'], "op": "setProject" }
    if (type == "members") params.members = selectObj.value
    else params.managers = selectObj.value
    commons.getAPIRes(params, "POST", "project").then(apiRes => {
      this.setState({
        status: true
      })
      if (apiRes.status) {
        this.setState({ message: params.members ? appMessages.addMemberSucMsg : appMessages.addManagersSucMsg })
      }
      else {
        this.setState({ message: params.members ? appMessages.addMemberFailMsg : appMessages.addManagersFailMsg })
      }
      setTimeout(function () {
        this.loadDefaults()
      }.bind(this), 2000)
    });
  };

  render() {
    const { status, message, formData, apiService, showForm, selectObj } = this.state;
    let { action, actionType } = this.props;

    let sortResult = util.sortArr(formData, "order");
    let chunk_size = 3;
    let groups = util.chunkArray(chunk_size, sortResult);

    return (
      <div>
        {apiService ? <LinearProgress /> : false}
        {commons.detectInternet()}

        <Card style={{ margin: "10px" }}>
          <CardContent>

            {showForm ?
              <div>
                <CustomSelect
                  inputData={selectObj}
                  onChange={this.handleChange}
                  onSelectChange={this.handleSelectChange}
                  onMultiSelectChange={
                    this.handleMultiSelectChange
                  }
                  editMode={true}
                />
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                  <Button
                    color="secondary"
                    variant="contained"
                    fullWidth
                    onClick={this.closeForm}
                    style={{ ...customStyles.submitBtn, width: 'fit-content', marginRight: 10 }}

                  >
                    Cancel
                  </Button>
                  <Button
                    type="Submit"
                    color="secondary"
                    variant="contained"
                    fullWidth
                    onClick={(e) => this.addUsers(e)}
                    style={{ ...customStyles.submitBtn, width: 'fit-content' }}

                  >
                    Submit
                  </Button>
                </div>
              </div>
              : false}

            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ flex: 1 }}></div>
              <Tooltip title={"Add Member"} style={{ flex: 1 }}>
                <AddCircle onClick={(e) => this.loadUsers(e, "createProject")} disabled={showForm} />
              </Tooltip>
            </div>



            <TableContainer component={Paper} sx={{ alignSelf: 'center', maxWidth: 650 }}>
              <Table size={"small"} aria-label="simple table">
                <TableHead style={tableOptions.headerStyle}>
                  <TableRow>
                    <TableCell style={{ textAlign: 'left' }}>Name</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>Email</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>Role</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.projectUsers
                    .map((row) => {
                      return (<TableRow style={tableOptions.cellStyle}>
                        <TableCell style={{ textAlign: 'left' }}> {util.titleCase(row.name)} </TableCell>
                        <TableCell style={{ textAlign: 'center' }}> {row.email} </TableCell>
                        <TableCell style={{ textAlign: 'center' }}> {row.role ? row.role.toLowerCase() : ''} </TableCell>

                      </TableRow>)
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>


        </Card>


        <SnackBarWidget message={message} status={status} />
      </div>
    );
  }
}

ProjectUser.propTypes = {
  id: PropTypes.string,
  cancelDialog: PropTypes.func,
  reloadPage: PropTypes.func,
  action: PropTypes.bool
};
export default ProjectUser;
